import { useState, useEffect } from "react";

export function useFilterPagination(data, options = {}) {
  const { defaultPageSize = 10, responsivePageSize = 20 } = options;

  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

  // Responsive page size based on window width
  useEffect(() => {
    function updatePageSize() {
      const width = window.innerWidth;
      setPageSize(width >= 1920 ? responsivePageSize : defaultPageSize);
    }
    updatePageSize();
    window.addEventListener("resize", updatePageSize);
    return () => window.removeEventListener("resize", updatePageSize);
  }, [defaultPageSize, responsivePageSize]);

  // Filter by search query (search in all fields)
  const filteredData = data.filter((item) =>
    Object.values(item).some((val) =>
      (val ?? "").toString().toLowerCase().includes(searchQuery.toLowerCase())
    )
  );

  // Sort filtered data

  const sortedData = sortConfig.key
    ? [...filteredData].sort((a, b) => {
      let aVal = a[sortConfig.key];
      let bVal = b[sortConfig.key];

      // handle null/undefined
      aVal = aVal ?? "";
      bVal = bVal ?? "";

      // 👉 detect date
      const isDate =
        !isNaN(Date.parse(aVal)) && !isNaN(Date.parse(bVal));

      if (isDate) {
        aVal = new Date(aVal);
        bVal = new Date(bVal);
      }

      // 👉 detect number
      else if (!isNaN(aVal) && !isNaN(bVal)) {
        aVal = Number(aVal);
        bVal = Number(bVal);
      }

      // 👉 fallback string
      else {
        aVal = aVal.toString().toLowerCase();
        bVal = bVal.toString().toLowerCase();
      }

      if (aVal < bVal) return sortConfig.direction === "asc" ? -1 : 1;
      if (aVal > bVal) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    })
    : filteredData;

  // const sortedData = sortConfig.key
  //   ? [...filteredData].sort((a, b) => {
  //     const aVal = a[sortConfig.key]?.toString().toLowerCase();
  //     const bVal = b[sortConfig.key]?.toString().toLowerCase();

  //     if (aVal < bVal) return sortConfig.direction === "asc" ? -1 : 1;
  //     if (aVal > bVal) return sortConfig.direction === "asc" ? 1 : -1;
  //     return 0;
  //   })
  //   : filteredData;

  // Reset to page 1 when search or sort changes
  useEffect(() => {
    setPage(1);
  }, [searchQuery, sortConfig]);

  // Pagination slicing
  const totalPages = Math.ceil(sortedData.length / pageSize);
  const paginatedData = sortedData.slice((page - 1) * pageSize, page * pageSize);

  const clearSearch = () => setSearchQuery("");

  return {
    searchQuery,
    setSearchQuery,
    clearSearch,
    page,
    setPage,
    pageSize,
    totalPages,
    paginatedData,
    sortConfig,
    setSortConfig,
    pageSize
  };
}
